import { Fab } from "@mui/material";
import areaPriceIcon from "assets/icons/pricing/ic_area_price.svg";
import React from "react";
import styles from "./PricingModeButton.module.scss";

export const PricingModeButton = React.memo(
  (props: { pricingMode: boolean; onQuitPricingClick: () => void }) => (
    <Fab
      onClick={props.onQuitPricingClick}
      className={styles.pricingModeButton}
    >
      <img src={areaPriceIcon} alt="ピンポイント査定モードOFF" />
    </Fab>
  )
);
